import React, { Component } from 'react';
import { BarChart, Bar, XAxis, YAxis, LabelList, ResponsiveContainer } from 'recharts';

const COLORS = ['#3d81ff', '#fd6094'];

class OfficeCntBarChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [props.office],
            maxCnt: props.maxCnt
        }
    }

    render() {
        const { data, maxCnt } = this.state;

        return (
            <ResponsiveContainer width="100%" height={26}>
                <BarChart
                    layout="vertical"
                    margin={{bottom: 5, right: 20}}
                    data={data}
                >
                    <XAxis type="number" hide domain={[0, maxCnt]} />
                    <YAxis dataKey="damdangOffice" type="category" hide />

                    <Bar type="number" dataKey="siteCnt" fill={COLORS[0]} minPointSize={1} barSize={7}>
                        <LabelList dataKey="siteCnt" content={<CustomizedLabel color={COLORS[0]} />} />
                    </Bar>
                    <Bar type="number" dataKey="totalCnt" fill={COLORS[1]} minPointSize={1} barSize={7}>
                        <LabelList dataKey="totalCnt" content={<CustomizedLabel color={COLORS[1]} />} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        );
    }
}

class CustomizedLabel extends Component {

    render() {
        const { x, y, width, height, value, color } = this.props;

        return (
            <>
                <text className=""
                    x={x * 2 + width}
                    y={y + height}
                    fill={color}
                    style={{ fontSize: 10 }}
                >
                    {value}
                </text>
            </>
        );
    }
}



export default OfficeCntBarChart;
